import { Link, Stack, styled } from '@mui/material';
import { MobileLinks } from '@schooly/constants';
import { FC } from 'react';

import AppStoreSvg from './appstore.svg';
import GooglePlaySvg from './google-play.svg';

export const DemoSchoolAppLinks: FC = () => {
  return (
    <AppLinksContainer>
      <Stack
        sx={(theme) => ({
          flex: 1,
          borderRadius: theme.spacing(1),
          textAlign: 'center',
          border: `1px solid ${theme.palette.primary.main}`,
        })}
      >
        <Link href={MobileLinks.iosApp}>
          <img className="app-store" src={AppStoreSvg} alt={MobileLinks.iosApp} />
        </Link>
      </Stack>

      <Stack
        sx={(theme) => ({
          flex: 1,
          borderRadius: theme.spacing(1),
          border: `1px solid ${theme.palette.primary.main}`,
        })}
      >
        <Link href={MobileLinks.androidApp}>
          <img className="google-play" src={GooglePlaySvg} alt={MobileLinks.androidApp} />
        </Link>
      </Stack>
    </AppLinksContainer>
  );
};

const AppLinksContainer = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',

  marginBottom: theme.spacing(3),
  gap: theme.spacing(2),

  '.app-store': {
    width: '88%',
    alignSelf: 'center',
  },
  '.google-play': {
    width: '100%',
  },

  [theme.breakpoints.up('sm')]: {
    display: 'none',
  },
}));
